import { buildAgentV2ReferenceViewerSession } from './build-agent-v2-reference-viewer-session'
import { ViewerDocumentKind } from '@/content-viewer/store/schemas'
import type { AgentV2Reference } from '@/agent-v2/store/schemas'
import { getAgencyPublisherUrl } from '@/agent-v2/agency-documents/utils/get-agency-publisher-url'

export function getAgentV2ExternalReferenceUrl(reference: AgentV2Reference): string | null {
  if (reference.source_type === 'web') return reference.source.url
  if (reference.source_type !== 'administrative_decision' || buildAgentV2ReferenceViewerSession(reference)) return null

  const url = getAgencyPublisherUrl(reference.source.source_url, reference.source.document_metadata.publisher_media_type)
  if (!url) return null
  const sentence = reference.support.selected_sentences[0]?.trim()
  if (sentence) {
    url.hash = `${url.hash || '#'}:~:text=${encodeURIComponent(sentence)}`
  }
  return url.toString()
}

/**
 * Whether clicking the reference's citation opens something on this surface. `opensInPanel` says
 * where the surface opens sources: the in-app content viewer, or a new browser tab (the narrow draft
 * workspace, the artifact editor outside the workspace panel, the artifact edit review). A docket's
 * saved record has no standalone page yet, so it opens only in the panel.
 */
export function canOpenAgentV2Reference(reference: AgentV2Reference, { opensInPanel }: { opensInPanel: boolean }): boolean {
  if (getAgentV2ExternalReferenceUrl(reference) !== null) return true

  const session = buildAgentV2ReferenceViewerSession(reference)
  if (session === null) return false
  // Mirrors the DOCKET case in resolveStandaloneViewerUrlFromSession; a standalone docket page must remove both.
  return opensInPanel || session.document.kind !== ViewerDocumentKind.DOCKET
}
